"use client";
import React from "react";
import "./boxstyle.css"; // Ensure this file exists and is styled appropriately

function VestWorks() {
  const steps = [
    {
      number: "1",
      image: "3square.png", // Replace with your actual image path or import
      title: "Prevents Dumping",
      description: "Long-term unlocks protect token value from sudden dumps",
    },
    {
      number: "2",
      image: "shield-tick.png",
      title: "Builds Trust",
      description: "Transparency shows our commitment to sustainable growth.",
    },
    {
      number: "3",
      image: "money-send.png",
      title: "Aligns Incentives",
      description: "Team and advisors earn as they contribute to the project.",
    },
  ];

  return (
    <div className="relative w-full h-auto overflow-x-hidden">
      {/* Background */}
<div className="w-full min-h-screen bg-none sm:bg-[url('../public/bgvest.png')] sm:bg-no-repeat sm:bg-cover sm:bg-center">

        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Baloo+2:wght@400;700;800&family=Inter:wght@400;500;600;700&display=swap"
        />

        <section className="overflow-hidden relative w-full min-h-screen flex justify-center items-center px-4">
          <div className="flex flex-col gap-16 max-w-[1344px] w-full items-start">
            {/* Header Section */}
            <header className="flex flex-col gap-6 justify-center items-start w-full max-w-3xl">
              <h1 className="text-7xl font-bold tracking-wider text-white leading-[72px] max-md:text-6xl max-sm:text-5xl">
                <span className="text-white font-fredoka">  Why  </span>
                <span className="font-fredoka text-6xl font-bold bg-clip-text max-md:text-5xl max-sm:text-4xl text-transparent bg-gradient-to-r from-[#FFA8D1] via-[#C3B1FF] to-[#AEE2FF]">
                Vesting Matters
                </span>
              </h1>

              {/* SVG Gradient Title */}
           

              <p className="text-xl text-neutral-100 leading-8 max-md:text-lg max-sm:text-base">
By gradually unlocking tokens, it prevents sudden sell-offs, aligns team incentives, and builds community confidence through transparent, responsible token distribution              </p>
            </header>

            {/* Steps Grid */}
            <div className="flex flex-col md:flex-row md:flex-wrap gap-6 w-full justify-start">
              {steps.map((step) => (
                <article
                  key={step.number}
                  className="flex frame-11 flex-col gap-4 p-6 rounded-xl border-2 border-solid backdrop-blur-[10px] bg-[#3a3350] bg-opacity-60 border-slate-800 border-opacity-10 w-full md:w-[432px]"
                >   <div className="w-full flex justify-start">
    <img
      src={step.image}
      alt={`Step ${step.number}`}
      className="w-[60px] h-[60px] object-contain"
    />
  </div>
                  <header className="flex justify-between items-center w-full">
                    <h2 className="text-3xl font-bold text-white max-md:text-2xl max-sm:text-xl">
                      {step.title}
                    </h2>
                
                  </header>
                  <p className="text-2xl text-neutral-100 leading-8 max-md:text-xl max-sm:text-lg">
                    {step.description}
                  </p>
                </article>
              ))}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default VestWorks;